module.exports = __webpack_public_path__ + "img/icon-chevron-up.3af13c9c.svg";